import {} from "@/api/user.js";
import { getCookie } from "@/utils/cookie";
import { checkModbile, validateEmail } from '@/utils/utils'

import { getAgent, createAgent, updateAgent, defaultData, meallist, purchasecode, aliCallBack, aliPaymentStatus, convertibility, mealTypeList } from "@/api/user.js";
import axios from 'axios'
import draggable from 'vuedraggable';
import { domainName } from '@/utils/domainName'


export default {
    name: 'priceDialog',
    components: {
        draggable,
    },
    computed: {},
    watch: {},
    data() {
        return {
            problemIndex: 0,
            dialogVisible: false,
            mealList: [],
            getindex: 0,
            getitem: [],
            geturl: '',
            access_token: '',
            loading: false,
            qr_url: '',
            order_id: '',
            timeoutId: null,
            pay_way: [],
            language: this.$store.state.language, //多语言
            get_pay_type: '', //支付方式 用来判断海外 联想 和标准
            contrastDialog: false,
            itemRefsExcel: [],
            visibleExchange: true,
            exchangeInput: '',
            vipList: [{
                    id: 1,
                    name: 'AI Excel',
                    type: 'excel'
                },
                {
                    id: 2,
                    name: '大文件处理',
                    type: 'excelMax'
                }, {
                    id: 3,
                    name: '图表生成',
                    type: 'chartGeneration'
                },
                // {
                //     id: 4,
                //     name: 'AI VOC',
                //     type: 'voc'
                // }
            ],
            vipIndex: 0,
            exchangeDialog: false,
            exchangeInput: '',
            userInfo: getCookie("userInfo") ? JSON.parse(getCookie("userInfo")) : '',

        }
    },
    created() {

    },

    mounted() {
        this.access_token = getCookie("access_token")
            // 联想回调
        if (this.$route.query.iframes) {
            this.getindex = 0
            this.getmealTypeList()
                // 扫码支付回调接口
            this.buyCallback()
        }
    },
    destroyed() {
        console.log(2)
        clearTimeout(this.timeoutId);
        this.timeoutId = null

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setInitialHeight);
    },
    methods: {
        init(index, vipIndex) {
            this.dialogVisible = true
            this.getindex = index
            this.vipIndex = vipIndex
            this.getmealTypeList()
                // 扫码支付回调接口
            this.buyCallback()
        },
        getmealTypeList() {
            mealTypeList({ access_token: getCookie("access_token"), }).then((res) => {
                this.vipList = res.data.data
                this.getExceltest()

            });
        },
        buyCallback() {
            if (this.language != 'zh_CN') {
                return
            }
            this.timeoutId = setTimeout(() => {
                if (!this.order_id) {
                    console.log(543)
                    this.buyCallback()
                    return
                }
                aliPaymentStatus({
                    access_token: getCookie("access_token"),
                    order_id: this.order_id
                }).then((res) => {
                    clearTimeout(this.timeoutId);
                    if (res.data.code == 0) {
                        if (res.data.data.pay_state == 1) {
                            clearTimeout(this.timeoutId);
                            this.$message.success("购买成功！");
                            window.parent.postMessage("buySuccess", "*");
                            location.reload()
                        } else {
                            this.buyCallback()
                        }
                    }
                });
            }, 2000);
        },

        handleTabClick(tab, event) {
            console.log(tab.name)
            this.scrollToSection(tab.name);
        },

        handleMouseEnter(tabId) {
            this.hoveredTab = tabId;
            this.activeTab = tabId
            this.goToSlide()
            this.$nextTick(() => this.$forceUpdate());

        },

        goToSlide() {
            const carousel = this.$refs.carouselRef;
            console.log(carousel)
            carousel.activeIndex = this.activeTab * 1
        },
        handleMouseLeave() {
            this.hoveredTab = null;
        },
        scrollToSection(sectionId) {
            const sectionElement = document.getElementById(sectionId);
            if (sectionElement) {
                sectionElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },

        handleClose(done) {
            clearTimeout(this.timeoutId);
            // this.$confirm('确认关闭？')
            //   .then(_ => {
            //     done();
            //   })
            //   .catch(_ => {});
        },
        // 点击购买
        goBuy(index) {
            if (!getCookie("access_token")) {
                this.$store.commit("setLoginDisplay", true);
            } else {
                this.getExceltest()
                this.getindex = index
                this.dialogVisible = true
            }

        },
        useBtn() {
            if (getCookie("access_token")) {
                location.href = domainName.api8 + '/#/sheet'
            } else {
                this.$store.commit("setLoginDisplay", true);
            }
        },
        // 选择购买时长
        clickType(item, index) {
            this.loading = true
            this.getindex = index
            this.getitem = item
            this.getqrCode()
        },
        // meallist, purchasecode 
        // 切换套餐
        clickVip(index) {
            this.vipIndex = index
            this.getindex = 0
            this.getitem = {}
            this.mealList = []
            this.itemRefsExcel = []
            this.getExceltest()
                // console.log(this.vipIndex, 9999)
            this.$forceUpdate();
        },
        //   套餐列表
        getExceltest() {
            this.loading = true
            meallist({ meal_type: this.vipList[this.vipIndex].value, access_token: getCookie("access_token"), }).then((res) => {
                if (res.data.code == 0) {
                    this.mealList = res.data.data
                    this.getitem = this.mealList[this.getindex]
                    setTimeout(() => {
                        this.itemRefsExcel[this.getindex].scrollIntoView({ behavior: 'smooth' });
                    }, 500);
                    this.getqrCode()
                    this.$forceUpdate()
                } else if (res.data.code == 20001) {
                    this.loading = false
                    this.$message.error(res.data.msg);
                    this.vipIndex = 0
                    this.getExceltest()
                }

            }).catch(() => {
                this.loading = false
            });
        },
        getqrCode() {
            let params = {
                meal_type: this.vipList[this.vipIndex].value,
                id: this.getitem.id,
                access_token: getCookie("access_token"),
            }
            if (window.jsbridge) {
                params.pay_type = 7
            } else if (this.language != 'zh_CN') {
                params.pay_type = 5
            } else {
                params.pay_type = 6
            }
            this.get_pay_type = params.pay_type
            purchasecode(params).then((res) => {
                if (res.data.code == 0) {
                    this.loading = false
                    this.geturl = res.data.data.url
                    this.qr_url = res.data.data.qr_url
                    this.order_id = res.data.data.order_id
                    this.pay_way = res.data.data.pay_way
                } else if (res.data.code == 20001) {
                    this.loading = false
                    this.$message.error(res.data.msg);
                    this.vipIndex = 0
                    this.getExceltest()
                }

            });
        },
        buyClick() {
            parent.location.href = this.geturl
            return
            // window.top.location.href =  this.geturl
            // parent.location.href = this.geturl
            if (window.jsbridge) {
                jsbridge.getLaunchOptions().then(res => {
                    window.parent.postMessage({ type: 'buy', url: this.geturl }, '*');
                })
            } else {
                location.href = this.geturl
            }
            // window.open(this.geturl)
        },
        // 协议
        goAgreement() {
            parent.location.href = domainName.api8 + "/#/user-agreement?tab=VIPAgreement";
        },

        // 权益对比
        contrast() {
            this.dialogVisible = false
            this.$parent.clickVip(this.vipIndex)
            return
            if (this.$route.query.iframes) {
                this.itemRefsExcel = []
            }
            // window.parent.postMessage("clickBuy", "*");
            this.contrastDialog = true

        },
        setItemRefExcel(el) {
            if (el) {
                this.itemRefsExcel.push(el);
            }
        },
        // 点击立即订阅
        nowBuy(index) {
            this.getindex = index
            this.$forceUpdate();
            this.getExceltest()
            if (!this.$route.query.iframes) {
                this.contrastDialog = false
            }
            console.log(this.itemRefsExcel)
            setTimeout(() => {
                this.itemRefsExcel[index].scrollIntoView({ behavior: 'smooth' });

            }, 100);
            this.$forceUpdate()

        },
        handlecontrastClose() {
            if (!this.$route.query.iframes) {
                this.contrastDialog = false

            }
            this.$forceUpdate()

        },
        // 确认兑换
        exchangeSure() {
            convertibility({ access_token: getCookie("access_token"), code: this.exchangeInput }).then((res) => {
                if (res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    this.handlecontrastClose()
                    this.getExceltest()
                } else {
                    this.$message.info(res.data.msg);
                }
            });
        },
        handleexchangeClose() {
            this.exchangeDialog = false
        },
        exchangeClick() {
            this.exchangeInput = ''
            this.exchangeDialog = true
        },
        // 确认兑换
        exchangeSure() {
            convertibility({ access_token: getCookie("access_token"), code: this.exchangeInput }).then((res) => {
                if (res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    getUserInfo({
                        login_token: getCookie("login_token"),
                        access_token: getCookie("access_token"),
                    }).then(res => {
                        if (res.data.code === 0) {
                            this.$store.commit('setUserInfo', JSON.stringify(res.data.data))
                        } else {
                            Message.error(res.data.msg)
                        }
                    })
                    this.exchangeDialog = false

                } else {
                    this.$message.info(res.data.msg);
                }
            });
        },
    }
}